module.exports = __webpack_public_path__ + "img/Stripe.dd6193df.png";